import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { HttpHelper } from '../shared/http-helper';

import {SystemControlElem} from './system-control-elem';

import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';

@Injectable()
export class SystemControlService {
     private _systemControlUrl = `api/data`;
 
    constructor(private httpHelper: HttpHelper) { }

    public getSystemControl(): Observable<SystemControlElem> {
            return this.httpHelper.get(`${this._systemControlUrl}/systemcontrol`)
    }
    private handleError(error: Response) {
         // in a real world app, we may send the server to some remote logging infrastructure
         // instead of just logging it to the console
                 
         //console.error(error);
         return Observable.throw(error.json().error || 'Server error');
    }
}


/** WEBPACK FOOTER **
 ** ./app/shared/system-control.service.ts
 **/